import { Elements } from '@/components';
import BrushIcon from '@/assets/icons/BrushIcon.svg';
import ShieldIcon from '@/assets/icons/Shield.svg';
import ChannelGaps from '@/assets/icons/ChannelGaps.svg';
import MissingSolutions from '@/assets/icons/MissingSolution.svg';
import Image from 'next/image';

interface WhyWeStartedProps {
    backgroundImage?: string;
    title?: string;
    description?: string;
}

export const WhyWeStarted = ({
    backgroundImage,
    title = 'Why We Started Predictable Benefits',
    description = 'The ICHRA market was broken. Platforms competed with their partners instead of empowering them. We built something different.',
}: WhyWeStartedProps = {}) => {
    return (
        <section
            className="overflow-hidden bg-gray-50 bg-cover bg-center bg-no-repeat px-5 pt-20 pb-20 md:px-10 lg:px-[79px]"
            style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined }}
        >
            <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-10">
                <div className="flex flex-col items-center justify-center gap-4">
                    <Elements.Title title={title} type="h1" className="text-center max-w-[356px] md:max-w-[470px] lg:max-w-none text-gray-900" />
                    <Elements.Description description={description} type="medium" className="max-w-[360px] text-center md:max-w-none lg:max-w-none text-gray-900" />
                </div>

                <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                    <Elements.InfoCard
                        title="White Labeled"
                        description="Platforms prioritized their own brands over their partners"
                        icon={<Image src={BrushIcon} alt="Brush" width={32} height={32} />}
                    />
                    <Elements.InfoCard
                        title="Brokers Losing AOR/BOR"
                        description="Brokers were losing client relationships and pricing power"
                        icon={<Image src={ShieldIcon} alt="Shield" width={32} height={32} />}
                    />
                    <Elements.InfoCard
                        title="Channel Gaps"
                        description="Carriers and TPAs needed better broker support tools"
                        icon={<Image src={ChannelGaps} alt="Channel Gaps" width={32} height={32} />}
                    />
                    <Elements.InfoCard
                        title="Missing Solutions"
                        description="Other platforms lack critical features for real-world use"
                        icon={<Image src={MissingSolutions} alt="Missing Solutions" width={32} height={32} />}
                    />
                </div>
            </div>
        </section>
    );
};
